import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { ASSETS } from "@/data/site";

// Consistent dark hero header used at the top of every interior page.
export const PageHero = ({ eyebrow, title, intro, image, watermark = false, align = "left", children }) => {
  return (
    <section className="relative isolate overflow-hidden navy-gradient">
      {image && (
        <div className="absolute inset-0 -z-10">
          <img src={image} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
        </div>
      )}
      <div className="absolute inset-0 -z-10 grain" />
      {watermark && (
        <img
          src={ASSETS.emblem}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute -right-16 -top-10 w-[460px] max-w-[60%] opacity-[0.06] select-none"
        />
      )}

      <div className="ssa-container relative pt-36 pb-20 lg:pt-44 lg:pb-28">
        <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
          {eyebrow && (
            <Reveal>
              <div className={`flex items-center gap-3 mb-5 ${align === "center" ? "justify-center" : ""}`}>
                <span className="h-px w-8" style={{ background: "var(--ssa-gold)" }} />
                <span className="eyebrow text-turquoise">{eyebrow}</span>
              </div>
            </Reveal>
          )}
          <Reveal delay={0.05}>
            <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">{title}</h1>
          </Reveal>
          {intro && (
            <Reveal delay={0.12}>
              <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/75 max-w-2xl">
                {align === "center" ? <span className="mx-auto block">{intro}</span> : intro}
              </p>
            </Reveal>
          )}
          {children && (
            <Reveal delay={0.2}>
              <div className="mt-8">{children}</div>
            </Reveal>
          )}
        </div>
      </div>

      <motion.div
        className="absolute bottom-0 inset-x-0 h-px"
        style={{ background: "linear-gradient(90deg, transparent, rgba(184,155,94,0.6), transparent)" }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      />
    </section>
  );
};
